import { render, staticRenderFns } from "./CurrentTimezone.vue?vue&type=template&id=8c234c52&"
import script from "./CurrentTimezone.vue?vue&type=script&lang=js&"
export * from "./CurrentTimezone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports